import React from 'react';
import { useSurvey } from './Context';

function QuestionToggle({ question }) {
    const { setCurrentQuestion } = useSurvey();

    const handleClick = () => {
        window.dataLayer.push({
            event: 'survey_question_click',
            value: question.id,
            page: window.location.pathname,
        });

        setCurrentQuestion(question);
    };

    return (
        <button className="question-select" onClick={handleClick}>
            {/* <span className="question-number">Question {question.id}</span> */}
            <span className="question-text">{question.text}</span>
        </button>
    );
}

export default QuestionToggle;
